
class HXFormFieldTable extends HXFormField {

    /** @private */
    copyElementRow = {};
    /** @private */
    copyElementColLabel = {};
    /** @private */
    copyElementColSelect = {};
    /** @private */
    copyElementCol = {};
    /** @private */
    addRowButton = "";
    /** @private */
    addColButton = "";
    /** @private */
    table = "";
    /** @private */
    moveCol = "";
    /** @private */
    moveRow = "";

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();
        return this.validationPassed;
    }

    /**
     * @private
     * @param {object} copyElementObject
     */
    setCopyObject(copyElementObject){
        this.copyElementRow = $(copyElementObject.row);
        this.copyElementColLabel = $(copyElementObject.col_label);
        this.copyElementColSelect = $(copyElementObject.col_select);
        this.copyElementCol = $(copyElementObject.col);
        this.refresh();
    };

    /**
     * @private
     * @return {any|string}
     */
    getCopyElements() {
        var tmp = JSON.parse(this.inputObj.getAttribute("data-hx-copyelements"));
        if (typeof tmp !== 'object' || tmp===null || tmp===undefined) return "";
        return tmp;
    }

    /**
     * @private
     */
    refresh(){
        var regexCol = "js-col-\\d+";
        var regexRow = "js-row-\\d+";

        var colKey = 1;
        $.each(this.table.find(".js-col_label"), (key, element) => {
            var $col = $(element);

            var colLabel = this.getColLabelDefault() + " " + colKey;
            if(this.getColLabels(colKey) !== "") colLabel = this.getColLabels(colKey);

            $col.find(".js-col_label_text").text(colLabel).data("col", colKey);
            $col.find(".js-move_col").data("col", colKey);
            $col.find(".js-remove_col").data("col", colKey);
            $col.find(".js-move_col_left").data("col", colKey);
            $col.find(".js-move_col_right").data("col", colKey);

            $col.removeClass((index, className) => {
                var re = new RegExp(regexCol, 'g');
                return (className.match(re) || []).join(' ');
            });
            $col.addClass("js-col-" + colKey);
            colKey++;
        });

        colKey = 1;
        $.each(this.table.find(".js-col_select"), (key, element) => {
            var $col = $(element);
            $col.removeClass((index, className) => {
                var re = new RegExp(regexCol, 'g');
                return (className.match(re) || []).join(' ');
            });

            $col.addClass("js-col-" + colKey);
            $col.find(".js-select_col").attr("name", this.inputName + "_options[col][" + colKey + "]");
            colKey++;
        });

        var rowKey = 1;
        $.each(this.table.find(".js-row"), (key, element) => {
            var $row = $(element);
            $row.data("row", rowKey);

            var rowLabel = this.getRowLabelDefault() + " " + rowKey;
            if(this.getRowLabels(rowKey) !== "") rowLabel = this.getRowLabels(rowKey);

            $row.find(".js-row_label_text").text(rowLabel);
            $row.find(".js-select_row").attr("name", this.inputName + "_options[row][" + rowKey + "]");

            $row.removeClass((index, className) => {
                var re = new RegExp(regexRow, 'g');
                return (className.match(re) || []).join(' ');
            });
            $row.addClass("js-row-" + rowKey);

            colKey = 1;
            $.each($row.find(".js-col"), (key, element) => {
                var $col = $(element);
                $col.removeClass((index, className) => {
                    var re = new RegExp(regexCol, 'g');
                    return (className.match(re) || []).join(' ');
                });
                $col.addClass("js-col-" + colKey);

                var inputWidth = this.getColWidth();
                if(typeof this.getColWidths(colKey) != "undefined") inputWidth = this.getColWidths(colKey);

                $col.find(".js-col_input").attr("name", this.inputName + "[" + rowKey + "][" + colKey + "]").css("width", inputWidth+"px");
                colKey++;
            });
            rowKey++;
        });

        rowKey--;
        colKey--;

        if(rowKey >= this.getMaxRows()){
            this.addRowButton.addClass("hx_form_field_table_disabled");
        }else{
            this.addRowButton.removeClass("hx_form_field_table_disabled");
        }

        if(colKey >= this.getMaxCols()){
            this.addColButton.addClass("hx_form_field_table_disabled");
        }else{
            this.addColButton.removeClass("hx_form_field_table_disabled");
        }

        if(rowKey <= this.getMinRows() && this.getMinRows() !== 0){
            this.table.find(".js-remove_row").addClass("hx_form_field_table_disabled");
        }else{
            this.table.find(".js-remove_row").removeClass("hx_form_field_table_disabled");
        }

        if(colKey <= this.getMinCols() && this.getMinCols() !== 0){
            this.table.find(".js-remove_col").addClass("hx_form_field_table_disabled");
        }else{
            this.table.find(".js-remove_col").removeClass("hx_form_field_table_disabled");
        }

        $("hx_form_field_table_del").removeClass("hx_form_field_table_del");
    };

    /**
     * Maximale Anzahl der Zeilen
     * @return {decimal}
     */
    getMaxRows() {
        return hx.cint(this.inputObj.getAttribute("data-hx-row-count-max"));
    };

    /**
     * Minimale Anzahl der Zeilen
     * @return {int}
     */
    getMinRows() {
        return hx.cint(this.inputObj.getAttribute("data-hx-row-count-min"));
    };

    /**
     * Maximale Anzahl der Spalten
     * @return {int}
     */
    getMaxCols() {
        return hx.cint(this.inputObj.getAttribute("data-hx-col-count-max"));
    };

    /**
     * Minimale Anzahl der Spalten
     * @return {int}
     */
    getMinCols() {
        return hx.cint(this.inputObj.getAttribute("data-hx-col-count-min"));
    };

    /**
     * Breite der ersten Spalte
     * @return {number}
     */
    getColWidth() {
        return hx.cint(this.inputObj.getAttribute("data-hx-col-width"));
    };


    /**
     * Spaltenbreiten
     * @param {string} key
     * @return {string}
     */
    getColWidths(key) {
        var tmp = JSON.parse(this.inputObj.getAttribute("data-hx-col-widths"));
        if (typeof tmp !== 'object' || tmp===null) return "";
        return tmp[key];
    };

    /**
     * Default Label der Spalten
     * @return {string}
     */
    getColLabelDefault() {
        return this.inputObj.getAttribute("data-hx-col-label-default");
    };

    /**
     * Individuelle Label der Spalten
     * @param {string} key
     * @return {string}
     */
    getColLabels(key) {
        var tmp = JSON.parse(this.inputObj.getAttribute("data-hx-col-labels"));
        if (typeof tmp !== 'object' || tmp===null || tmp[key]===undefined) return "";
        return tmp[key];
    };

    /**
     * Default max. Eingabelaenge
     * @return {string}
     */
    getMaxLengthDefault() {
        return hx.cint(this.inputObj.getAttribute("data-hx-maxlength-default"));
    };

    /**
     * Spalten max. Eingabel�nge
     * @param {string} key
     * @return {string}
     */
    getMaxLengthCols(key) {
        var tmp = JSON.parse(this.inputObj.getAttribute("data-hx-col-maxlengths"));
        if (typeof tmp !== 'object' || tmp===null || tmp[key]===undefined) return "";
        return tmp[key];
    };

    /**
     * Default Label der Zeilen
     * @return {string}
     */
    getRowLabelDefault() {
        return this.inputObj.getAttribute("data-hx-row-label-default");
    };

    /**
     * Individuelle Label der Zeilen
     * @param {string} key
     * @return {string}
     */
    getRowLabels(key) {
        var tmp = JSON.parse(this.inputObj.getAttribute("data-hx-row-labels"));
        if (typeof tmp !== 'object' || tmp===null || tmp[key]===undefined) return "";
        return tmp[key];
    };

    /**
     * @param {boolean} optional = true, (false nicht verfuegbar)
     */
    setOptional(optional) {
        super.setOptional(true,"formfieldpopup"); //false nicht verfuegbar
    }

    /**
     * setValue() nicht verfuegbar
     */
    setValue() {}

    /**
     * getValue() nicht verfuegbar
     * @return {null}
     */
    getValue() {return null;}

    /**
     * @private
     * @param {JQuery} $row
     */
    addRowEvents($row){

        $row.find(".js-row_label_text").on("click", (event) => {
            $(event.currentTarget).parents(".js-row").toggleClass("hx_form_field_table_focus");
            $("hx_form_field_table_del").removeClass("hx_form_field_table_del");
        });

        $row.find(".js-move_row").on("click", (event) => {
            event.preventDefault();
            this.table.find(".js-move_row_up").css('display','inline-flex');
            this.table.find(".js-move_row_down").css('display','inline-flex');
            this.table.find(".js-move_row").hide();
            this.table.find(".js-remove_row").hide();

            $(event.currentTarget).parents(".js-row_label").find(".js-move_row_up").hide();
            $(event.currentTarget).parents(".js-row_label").find(".js-move_row_down").hide();
            $(event.currentTarget).parents(".js-row_label").find(".js-move_row_abort").css('display','inline-flex');
            this.moveRow = $(event.currentTarget).parents(".js-row");
            $("hx_form_field_table_del").removeClass("hx_form_field_table_del");
        });

        $row.find(".js-move_row_up").on("click", (event) => {
            event.preventDefault();
            var $row = $(event.currentTarget).parents(".js-row");
            this.moveRow.insertBefore($row);
            this.table.find(".js-move_row_up").hide();
            this.table.find(".js-move_row_down").hide();
            this.table.find(".js-move_row_abort").hide();
            this.table.find(".js-move_row").show();
            this.table.find(".js-remove_row").show();
            this.refresh();
        });

        $row.find(".js-move_row_down").on("click", (event) => {
            event.preventDefault();
            var $row = $(event.currentTarget).parents(".js-row");
            this.moveRow.insertAfter($row);
            this.table.find(".js-move_row_up").hide();
            this.table.find(".js-move_row_down").hide();
            this.table.find(".js-move_row_abort").hide();
            this.table.find(".js-move_row").show();
            this.table.find(".js-remove_row").show();
            this.refresh();
        });

        $row.find(".js-move_row_abort").on("click", (event) => {
            event.preventDefault();
            this.table.find(".js-move_row_up").hide();
            this.table.find(".js-move_row_down").hide();
            this.table.find(".js-move_row_abort").hide();
            this.table.find(".js-move_row").show();
            this.table.find(".js-remove_row").show();
            $("hx_form_field_table_del").removeClass("hx_form_field_table_del");
        });

        $row.find(".js-remove_row").on("click", (event) => {
            event.preventDefault();
            if($(event.currentTarget).hasClass("hx_form_field_table_del")){
                $(event.currentTarget).parents(".js-row").remove();
                this.refresh();
            }else{
                $(event.currentTarget).addClass("hx_form_field_table_del");
            }
        });
    };

    /**
     * @private
     * @param {JQuery} $col
     */
    addColEvents($col){

        $col.find(".js-col_label_text").on("click", (event) => {
            var targetCol = $(event.currentTarget).data("col");

            $(event.currentTarget).parents(".js-col_label").toggleClass("hx_form_field_table_focus");
            $(".js-table_head_select").find(".js-col-" + targetCol).toggleClass("hx_form_field_table_focus");

            $.each(this.table.find(".js-row"), (key, element) => {
                var $row = $(element);
                $row.find(".js-col-" + targetCol).toggleClass("hx_form_field_table_focus");
            });
            $("hx_form_field_table_del").removeClass("hx_form_field_table_del");
        });

        $col.find(".js-move_col").on("click", (event) => {
            event.preventDefault();
            this.table.find(".js-move_col_left").css('display','inline-flex');
            this.table.find(".js-move_col_right").css('display','inline-flex');
            this.table.find(".js-move_col").hide();
            this.table.find(".js-remove_col").hide();
            this.moveCol = $(event.currentTarget).data("col");
            $(event.currentTarget).parents(".js-col_label").find(".js-move_col_left").hide();
            $(event.currentTarget).parents(".js-col_label").find(".js-move_col_right").hide();
            $(event.currentTarget).parents(".js-col_label").find(".js-move_col_abort").css('display','inline-flex');
            this.table.find(".js-col-"+$(event.currentTarget).data("col"));
            $("hx_form_field_table_del").removeClass("hx_form_field_table_del");
        });

        $col.find(".js-move_col_left").on("click", (event) => {
            event.preventDefault();
            var targetCol = $(event.currentTarget).data("col");

            var $row = $(".js-table_head_select");
            $row.find(".js-col-" + this.moveCol).insertBefore($row.find(".js-col-" + targetCol));

            $.each(this.table.find(".js-row"), (key, element) => {
                var $row = $(element);
                $row.find(".js-col-" + this.moveCol).insertBefore($row.find(".js-col-" + targetCol));
            });

            this.table.find(".js-move_col_left").hide();
            this.table.find(".js-move_col_right").hide();
            this.table.find(".js-move_col_abort").hide();
            this.table.find(".js-move_col").show();
            this.table.find(".js-remove_col").show();
            this.table.find(".js-col-"+this.moveCol);
            this.refresh();
        });

        $col.find(".js-move_col_right").on("click", (event) => {
            event.preventDefault();
            var targetCol = $(event.currentTarget).data("col");

            var $row = $(".js-table_head_select");
            $row.find(".js-col-" + this.moveCol).insertAfter($row.find(".js-col-" + targetCol));

            $.each(this.table.find(".js-row"), (key, element) => {
                var $row = $(element);
                $row.find(".js-col-" + this.moveCol).insertAfter($row.find(".js-col-" + targetCol));
            });

            this.table.find(".js-move_col_left").hide();
            this.table.find(".js-move_col_right").hide();
            this.table.find(".js-move_col_abort").hide();
            this.table.find(".js-move_col").show();
            this.table.find(".js-remove_col").show();
            this.table.find(".js-col-"+this.moveCol);
            this.refresh();
        });

        $col.find(".js-move_col_abort").on("click", (event) => {
            event.preventDefault();
            this.table.find(".js-move_col_left").hide();
            this.table.find(".js-move_col_right").hide();
            this.table.find(".js-move_col_abort").hide();
            this.table.find(".js-move_col").show();
            this.table.find(".js-remove_col").show();
            $("hx_form_field_table_del").removeClass("hx_form_field_table_del");
        });

        $col.find(".js-remove_col").on("click", (event) => {
            event.preventDefault();
            if($(event.currentTarget).hasClass("hx_form_field_table_del")){
                this.table.find(".js-col-" + $(event.currentTarget).data("col")).remove();
                this.refresh();
            }else{
                $(event.currentTarget).addClass("hx_form_field_table_del")
            }
        });
    };


    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true && this.getEditable()===true) {

                this.table = $(".js-" + this.inputName + "-table");
                this.addRowButton = this.table.find(".js-add_row");
                this.addColButton = this.table.find(".js-add_col");

                $.each(this.table.find(".js-row"), (key, element) => {
                    this.addRowEvents($(element));
                });

                $.each(this.table.find(".js-col_label"), (key, element) => {
                    this.addColEvents($(element));
                });

                this.setCopyObject(this.getCopyElements());

                //Neue Zeile einfuegen
                this.addRowButton.on("click", (event) => {
                    var $newRow = this.copyElementRow.clone();

                    $.each(this.table.find(".js-col_label_text"), (key, element) => {
                        var $copyCol = this.copyElementCol.clone();
                        if($(element).parents(".js-col_label").hasClass("hx_form_field_table_focus"))$copyCol.addClass("hx_form_field_table_focus");
                        $newRow.append($copyCol);
                    });
                    this.addRowEvents($newRow);
                    $newRow.insertBefore(this.table.find(".js-row_add"));
                    this.refresh();
                });

                //Neue Spalte einfuegen
                this.addColButton.on("click", (key, element) => {
                    var $newColLabel = this.copyElementColLabel.clone();
                    var $newColSelect = this.copyElementColSelect.clone();

                    this.addColEvents($newColLabel);

                    $newColLabel.insertBefore(this.table.find(".js-col_add"));
                    this.table.find(".js-table_head_select").append($newColSelect);

                    $.each(this.table.find(".js-row"), (key, element) => {
                        var $newCol = this.copyElementCol.clone();
                        $(element).append($newCol);
                    });
                    this.refresh();
                });


                // Focus und Blur Events:
                let $container = $(this.inputObj);

                // Event-Handler f�r focusin
                $container.on("focusin",  (event) => {
                    if ($container.attr("data-has_focus") != "1") {
                        $container.attr("data-has_focus", "1");
                        this.inputObj.dispatchEvent(new Event('focus'));
                    }
                });

                // Event-Handler f�r focusout
                $container.on("focusout", (event)=> {
                    // �berpr�fen, ob der Fokus aus dem gesamten Container verloren geht (nicht innerhalb der Kinder-Elemente bleibt)
                    if (!$.contains($container[0], event.relatedTarget)) {
                        if ($container.attr("data-has_focus") == "1") {
                            $container.attr("data-has_focus", "0");
                            this.inputObj.dispatchEvent(new Event('blur'));
                        }
                    }
                });


        }
    }

}




